import { throttle } from "lodash";
import { useCallback, useRef } from "react";

// FUTURE: Move this hook to the hooks lib. And call it useThrottleFn instead.
/* tslint:disable */
/* eslint-disable */
type IgnoreAny = any;

export function useThrottledCallback<T extends (...args: any[]) => void>(
  callback: T,
  delay: number
): (...args: Parameters<T>) => void {
  const callbackRef = useRef(callback);

  // Update the ref to always store the latest callback
  callbackRef.current = callback;

  return useCallback(
    throttle((...args: Parameters<T>) => {
      callbackRef.current(...args);
    }, delay),
    [delay] // Ensure the throttle delay is applied
  );
}
